<template>
  <b-card id="cr-parent" class="card-stock shadow-none mx-0" no-body>
    <!--      Card header-->
    <b-card-header class="px-0">
      <b-card-title>
        <span class="font-weight-bold">Choisissez le stock à approvisionner : </span>
      </b-card-title>

    </b-card-header>

    <!--      Card body-->
    <b-card-body class="px-0">
      <div v-if="isLoading" class="d-flex justify-content-center my-3">
        <b-spinner style="width: 4rem; height: 4rem" />
      </div>
      <div v-else>
        <b-list-group v-if="stocksList.length > 0" flush>
          <b-list-group-item
            v-for="(stock, i) in stocksList"
            :key="stock.uid"
            @click="showStock(stock)"
            class="d-flex justify-content-between align-items-center"
            button
          >
            <span>{{ i + 1 }}. {{ stock.name }}</span>
            <b-badge variant="primary" pill class="badge-round">
                            {{ stock.products_count }}
            </b-badge>
          </b-list-group-item>
        </b-list-group>
        <i v-else>Aucun stock disponible.</i>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BBadge,
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BListGroup,
  BListGroupItem,
  BSpinner,
} from "bootstrap-vue";

import { createNamespacedHelpers } from "vuex";
import ToastNotificationContent from "@core/components/toastification/ToastificationContent.vue";

const { mapGetters, mapMutations, mapActions } =
  createNamespacedHelpers("stock");

export default {
  name: "StocksViewStocksList",
  components: {
    BBadge,
    BSpinner,
    BCardBody,
    BListGroup,
    BCard,
    BCardHeader,
    BCardTitle,
    BListGroupItem,

    // eslint-disable-next-line vue/no-unused-components
    ToastNotificationContent,
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isLoading: {
      get: function () {
        return this.loading;
      },
      set: function (val) {
        this.$emit("update:loading", val);
      },
    },
    ...mapGetters({
      stocksList: "all",
    }),
  },
  mounted() {
    this.getAllStocks();
  },
  methods: {
    ...mapActions(["allStocks"]),
    ...mapMutations({
      setCurrentStock: "SET_RESOURCE",
    }),
    showStock(stock) {
      this.setCurrentStock(stock);
      this.$router.push({
        name: "apps-stock-provide",
        params: { id: this.$route.params.id, stock_id: stock.uid },
      });
    },
    async getAllStocks() {
      try {
        this.isLoading = true;
        await this.allStocks(this.$route.params.id);
      } catch (e) {
        this.$emit(
          "stock-handled",
          "Erreur de récupération de la liste des stocks",
          "AlertTriangleIcon",
          "danger"
        );
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
